import { render, staticRenderFns } from "./Personal-Info.vue?vue&type=template&id=10db6f6a&scoped=true"
import script from "./Personal-Info.vue?vue&type=script&lang=js"
export * from "./Personal-Info.vue?vue&type=script&lang=js"
import style0 from "./Personal-Info.vue?vue&type=style&index=0&id=10db6f6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db6f6a",
  null
  
)

export default component.exports